"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Value = exports.Op = exports.Field = exports.Bubble = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _recompose = require("recompose");

var _Flex = require("../Flex");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Bubble = function Bubble(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "".concat(className, " sqon-bubble")
  }, props), /*#__PURE__*/_react["default"].createElement("div", null, children));
};

exports.Bubble = Bubble;

var Field = function Field(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/_react["default"].createElement(Bubble, _extends({
    className: "sqon-field"
  }, props), children);
};

exports.Field = Field;

var Op = function Op(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/_react["default"].createElement(Bubble, _extends({
    className: "sqon-op"
  }, props), children);
};

exports.Op = Op;

var Value = function Value(_ref4) {
  var children = _ref4.children,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      props = _objectWithoutProperties(_ref4, ["children", "className"]);

  return /*#__PURE__*/_react["default"].createElement(Bubble, _extends({
    className: "sqon-value ".concat(className)
  }, props), children);
};

exports.Value = Value;
var enhance = (0, _recompose.compose)((0, _recompose.defaultProps)({
  FieldCrumb: function FieldCrumb(_ref5) {
    var field = _ref5.field,
        nextSQON = _ref5.nextSQON;
    return /*#__PURE__*/_react["default"].createElement(Field, {
      onClick: function onClick() {
        return console.log(nextSQON);
      }
    }, field);
  },
  ValueCrumb: function ValueCrumb(_ref6) {
    var value = _ref6.value,
        nextSQON = _ref6.nextSQON,
        props = _objectWithoutProperties(_ref6, ["value", "nextSQON"]);

    return /*#__PURE__*/_react["default"].createElement(Value, _extends({
      onClick: function onClick() {
        return console.log(nextSQON);
      }
    }, props), value);
  },
  Clear: function Clear(_ref7) {
    var nextSQON = _ref7.nextSQON;
    return /*#__PURE__*/_react["default"].createElement(Bubble, {
      className: "sqon-clear",
      onClick: function onClick() {
        return console.log(nextSQON);
      }
    }, "Clear");
  }
}), (0, _recompose.withState)('expanded', 'setExpanded', []), (0, _recompose.withProps)(function (_ref8) {
  var expanded = _ref8.expanded;
  return {
    isExpanded: function isExpanded(valueSQON) {
      return expanded.includes(valueSQON);
    }
  };
}), (0, _recompose.withHandlers)({
  onLessClicked: function onLessClicked(_ref9) {
    var expanded = _ref9.expanded,
        setExpanded = _ref9.setExpanded;
    return function (valueSQON) {
      setExpanded((0, _lodash.xor)(expanded, [valueSQON]));
    };
  }
}));

var SQON = function SQON(_ref10) {
  var _ref10$emptyMessage = _ref10.emptyMessage,
      emptyMessage = _ref10$emptyMessage === void 0 ? 'Start by selecting filters' : _ref10$emptyMessage,
      sqon = _ref10.sqon,
      FieldCrumb = _ref10.FieldCrumb,
      ValueCrumb = _ref10.ValueCrumb,
      Clear = _ref10.Clear,
      isExpanded = _ref10.isExpanded,
      expanded = _ref10.expanded,
      setExpanded = _ref10.setExpanded,
      onLessClicked = _ref10.onLessClicked;
  var sqonContent = (sqon === null || sqon === void 0 ? void 0 : sqon.content) || [];
  var isEmpty = sqonContent.length === 0;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sqon-view ".concat(isEmpty ? 'sqon-view-empty' : '')
  }, isEmpty && /*#__PURE__*/_react["default"].createElement("div", {
    className: "sqon-empty-message"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sqon-empty-message-arrow"
  }, "\u2190"), " ".concat(emptyMessage)), sqonContent.length >= 1 && /*#__PURE__*/_react["default"].createElement(_Flex.Row, {
    wrap: true
  }, /*#__PURE__*/_react["default"].createElement(_Flex.Row, {
    className: "sqon-group",
    key: "clear",
    style: {
      alignItems: 'center'
    }
  }, Clear({
    nextSQON: null
  })), sqonContent.map(function (valueSQON, i) {
    var op = valueSQON.op,
        _valueSQON$content = valueSQON.content,
        field = _valueSQON$content.field,
        fields = _valueSQON$content.fields,
        entity = _valueSQON$content.entity;
    var value = [].concat(valueSQON.content.value || []);
    var isSingleValue = !Array.isArray(value) || value.length === 1;
    return /*#__PURE__*/_react["default"].createElement(_Flex.Row, {
      className: "sqon-group",
      key: "".concat(field || fields.join(), ".").concat(op, ".").concat(value.join()),
      style: {
        alignItems: 'center'
      }
    }, FieldCrumb({
      field: op === 'filter' ? entity ? "".concat(entity, ".").concat(op) : op : field,
      nextSQON: (0, _utils.toggleSQON)({
        op: 'and',
        content: [valueSQON]
      }, sqon)
    }), /*#__PURE__*/_react["default"].createElement(Op, null, op === 'in' && isSingleValue || op === 'filter' ? 'is' : op), value.length > 1 && /*#__PURE__*/_react["default"].createElement("span", {
      className: "sqon-value-group sqon-value-group-start"
    }, "("), (isExpanded(valueSQON) ? value : (0, _lodash.take)(value, 2)).map(function (value, i) {
      return ValueCrumb({
        field: field,
        key: value,
        value: value,
        className: isSingleValue ? 'sqon-value-single' : '',
        nextSQON: op === 'filter' ? (0, _utils.replaceFilterSQON)({
          op: 'and',
          content: [{
            op: op,
            content: _objectSpread({}, entity && {
              entity: entity
            })
          }]
        }, sqon) : (0, _utils.toggleSQON)({
          op: 'and',
          content: [{
            op: op,
            content: {
              field: field,
              value: [value]
            }
          }]
        }, sqon)
      });
    }), value.length > 2 && !isExpanded(valueSQON) && /*#__PURE__*/_react["default"].createElement("span", {
      className: "sqon-more",
      onClick: function onClick() {
        return onLessClicked(valueSQON);
      }
    }, "\u2026"), isExpanded(valueSQON) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "sqon-less",
      onClick: function onClick() {
        return onLessClicked(valueSQON);
      }
    }, "Less"), value.length > 1 && /*#__PURE__*/_react["default"].createElement("span", {
      className: "sqon-value-group sqon-value-group-end"
    }, ")"), i < sqonContent.length - 1 && /*#__PURE__*/_react["default"].createElement(Op, null, sqon.op));
  })));
};

var _default = enhance(SQON);

exports["default"] = _default;